module.exports = __webpack_public_path__ + "img/BellNotification.d050f980.svg";